/*
 * video-lite.js
 * Click-to-play YouTube facade.
 *
 * Why this exists:
 *  - The stock `video` section emitted loop=1 + playlist=<id> and relied on
 *    lazysizes to swap data-src -> src. That combination is what produced
 *    "Video player configuration error" on mobile.
 *  - Autoplay must be muted by browser policy, so any autoplay embed is
 *    silent forever. Here the iframe is created inside the click handler,
 *    which keeps the user-activation gesture, so autoplay=1 WITHOUT mute=1
 *    is allowed and the video plays with sound.
 *
 * Bind once, delegate from document, so theme-editor section reloads and
 * any number of sections on the page all work with no re-init.
 */
(function () {
  if (window.__ytLiteInit) return;
  window.__ytLiteInit = true;

  var PARAMS = 'autoplay=1&playsinline=1&rel=0&modestbranding=1&iv_load_policy=3';

  function play(trigger) {
    if (trigger.getAttribute('data-ytlite-loaded') === '1') return;

    var id = trigger.getAttribute('data-ytlite-id');
    if (!id) return;

    trigger.setAttribute('data-ytlite-loaded', '1');

    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?' + PARAMS;
    iframe.title = trigger.getAttribute('data-ytlite-title') || 'Video';
    iframe.setAttribute('frameborder', '0');
    // "autoplay" in allow= is required or the tap-initiated play is blocked.
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('allowfullscreen', '');

    trigger.parentNode.insertBefore(iframe, trigger);
    trigger.setAttribute('hidden', '');
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var trigger = event.target.closest('[data-ytlite-id]');
    if (!trigger) return;
    event.preventDefault();
    play(trigger);
  });
})();